import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Loader2 } from "lucide-react";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Overview from "@/pages/Overview";
import Retention from "@/pages/Retention";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import ClinicalNotes from "@/pages/ClinicalNotes";
import ClinicalBrain from "@/pages/ClinicalBrain";
import Builder from "@/pages/Builder";
import PlanHistory from "@/pages/PlanHistory";
import SettingsPage from "@/pages/Settings";
import Reception from "@/pages/Reception";
import Recalls from "@/pages/Recalls";
import Appointments from "@/pages/Appointments";
import PortalPublic from "@/pages/PortalPublic";
import BookPublic from "@/pages/BookPublic";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="grid min-h-screen place-items-center bg-slate-50"><Loader2 className="h-6 w-6 animate-spin text-teal-600" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/book" element={<BookPublic />} />
            <Route path="/portal" element={<PortalPublic />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Protected><Overview /></Protected>} />
            <Route path="/retention" element={<Protected><Retention /></Protected>} />
            <Route path="/patients" element={<Protected><Patients /></Protected>} />
            <Route path="/patients/:id" element={<Protected><PatientDetail /></Protected>} />
            <Route path="/notes" element={<Protected><ClinicalNotes /></Protected>} />
            <Route path="/brain" element={<Protected><ClinicalBrain /></Protected>} />
            <Route path="/builder" element={<Protected><Builder /></Protected>} />
            <Route path="/history" element={<Protected><PlanHistory /></Protected>} />
            <Route path="/reception" element={<Protected><Reception /></Protected>} />
            <Route path="/appointments" element={<Protected><Appointments /></Protected>} />
            <Route path="/recalls" element={<Protected><Recalls /></Protected>} />
            <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
